module.exports = __webpack_public_path__ + "static/media/telephone.bc295811.png";